module.exports = __webpack_public_path__ + "img/V38.3fabd126.jpg";